<template>
    <uploadList uploadType="audio" uploadTitle="点击上传本地音频" btnTitle="" :accept="['.mp3']" :limit="11" uploadSize="2gb"></uploadList>
</template>
<script>
import uploadList from '../../components/uploadList/index.vue'
export default {
    name: 'Aduio',
    data() {
        return {
        }
    },
    components: {
        uploadList
    }
}
</script>
<style lang="less" scoped>

</style>